var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('indexList',{attrs:{"showTitle":_vm.showTitle,"showPage":_vm.showPage,"showTime":_vm.showTime,"toSpan":'dynamics',"type":2}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }